export const DEFAULT_COUNTRY_CODE = "US";

export const DEFAULT_FORM_YES_NO = "No";